/**
 * [공통] 사용자 로그인 정보
 * @module @helpers/security
 */
import store from '@/user/store'
import Cookies from 'js-cookie'

/**
 * @alias module:@helpers/security
 * @method checkUserInfo
 * @returns {boolean} 로그인 상태
 */
export async function checkUserInfo() {
  const sessionKey = Cookies.get('TOAST_ID_NEO3_SES') || Cookies.get('NHN_CLOUD_ID_NEO3_SES')
  const userInfo = store.getters['SecurityStore/userInfo']

  if (sessionKey) {
    if (userInfo) return true
    return await store.dispatch('SecurityStore/registerUserInfo')
  } else {
    await store.dispatch('SecurityStore/unregisterUserInfo')
    return false
  }
}

/**
 * @alias module:@helpers/security
 * @method maskingEmail
 * @param {string} value 사용자 email
 * @returns {string} 사용자 email 마스킹 처리 결과
 */
export function maskingEmail(value) {
  if (!value || typeof value !== 'string') {
    console.error('Invalid email value:', value)
    return ''
  }
  const totalLen = value.split('@')[0].length
  const maskingLen = totalLen - 3
  return value.replace(new RegExp('.(?=.{0,' + maskingLen + '}@)', 'g'), '*')
}

/**
 * @alias module:@helpers/security
 * @method maskingName
 * @param {string} value 사용자 이름
 * @returns {string} 사용자 이름 마스킹 처리 결과
 */
export function maskingName(value) {
  if (!value || typeof value !== 'string') {
    console.error('Invalid name value:', value)
    return ''
  }
  let origin = Array.from(value)
  if (origin.length > 2) {
    origin.forEach(function (value, index) {
      if (index === 0 || index === origin.length - 1) return
      origin[index] = '*'
    })
    return origin.join().replaceAll(',', '')
  } else {
    return value.replace(/.$/, '*')
  }
}

export default {
  checkUserInfo,
  maskingEmail,
  maskingName,
}
